import { FC, useState } from "react";
import { AppButton } from "site/ui";
import styled from "styled-components";
import DeleteAccountConfirmation from "./DeleteAccountConfirmation";

const SectionTitle = styled.h2`
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: 600;
    color: #5575f7;
`;
const SubText = styled.p`
  margin: 5px 0;
  font-size: 14px;
  color: #6c757d;
`;

export interface AccountMgtProps {
    onDeleteAccount: () => Promise<void>;
}
export const AccountMgt:FC<AccountMgtProps> = ({
    onDeleteAccount
}) => {
    const [openModal, setOpenModal] = useState(false)
    return (
      <div>
        <SectionTitle>Manage account</SectionTitle>
        <div>
          <h4>Delete account</h4>
          <SubText>
            Deleting your account will permanently remove all your data and
            cannot be undone.
          </SubText>
          <AppButton
            variant="delete"
            style={{ marginTop: 20 }}
            onClick={() => setOpenModal(true)}
          >
            Delete my account
          </AppButton>
        </div>
        <DeleteAccountConfirmation {...{
            isOpen: openModal,
            onClose: () => setOpenModal(false),
            onConfirm: onDeleteAccount,
        }}/>
      </div>
    );
  };